var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-main"},[_c('kf-header'),_c('router-view'),_c('kf-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }